import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NestApiProvider } from '../../nest-api';
import { responseObj } from '../../nest-model/nest-model';


/*
  Generated class for the AccessManagementProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class Sf6Spt1721A1Provider {

  module: string = '';
  model: string = 'sf6s/spt1721a1';

  constructor(
    public http: HttpClient,
    public nestApi: NestApiProvider
  ) {

    
  }
  
  listingspt1721a1(limit) {
    const method: string = "GET";
    const model: string = this.model;
    const func: string = "listingSpt1721A1";
    const params: any = {};
    const urlParams: any = limit;
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<responseObj<any>>(method, url, params, urlParams, body, contentType);
  }

}



// WEBPACK FOOTER //
// ./src/shared/nestjs/payroll/form-1721-a-1/sf6-spt1721a1.api.ts